module.exports = __webpack_public_path__ + "img/login-dark.ace715a3.svg";